// extracted by mini-css-extract-plugin
export var billingAddress = "_r7-f";
export var contactInfo = "_r7-c";
export var customerInfoContainer = "_r7-b";
export var customerInfoRow = "_r7-9";
export var customerInfoSection = "_r7-a";
export var fullWidthDividerMobile = "_r7-g";
export var imageContainer = "_r7-1";
export var paymentMethod = "_r7-d";
export var priceText = "_r7-6";
export var priceTextMobile = "_r7-7";
export var product = "_r7-0";
export var productImage = "_r7-2";
export var productInfo = "_r7-4";
export var productTitle = "_r7-8";
export var quantityBadge = "_r7-3";
export var quantityText = "_r7-5";
export var shippingAddress = "_r7-e";